package fr.arcplex.sooner

actual val useCoherence: Boolean = true
